
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Index = () => {
  return <div className="min-h-screen">
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center px-4">
          <div className="flex justify-center mb-4">
            <img 
              src="/lovable-uploads/66023641-2dd1-4bcf-b639-4e8db23321d2.png" 
              alt="Thoroughgood Development Logo" 
              className="w-32 h-32 object-contain"
            />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-slate-900">Thoroughgood </span>
            <span className="bg-gradient-to-r from-[#7459EF] to-[#b344ef] bg-clip-text text-transparent">
              Development
            </span>
          </h1>
          <p className="text-lg text-slate-600 mb-8 max-w-md mx-auto">Administration portal</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/auth">
              <Button className="bg-gradient-to-r from-[#7459EF] to-[#b344ef] hover:opacity-90 transition-opacity border-none">
                Get Started
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>;
};

export default Index;
